module.exports = __webpack_public_path__ + "img/top.f26fa4d5.png";